import React from "react";
import { Astronaut } from "../components/astronautAnimation";
import Hint from "../components/Hint";

export function HomeView(props) {
  const dynamicButton = () => {
    if (props.suspense === false) {
      return (
        <button className="btn-primary" onClick={() => props.toGameplay()}>
          Let's Play!
        </button>
      );
    }
    if (props.suspense === true) {
      return (
        <img
          className="size-16"
          src="/assets/images/spinner.gif"
          alt="loading"
        />
      );
    }
  };

  return (
    <div className="relative flex flex-col w-full h-full items-center justify-center">
      <h1 className="absolute top-40 text-3xl text-center">
        Feel like an Astronaut and guess the planets!
      </h1>
      <Astronaut />
      <div className="absolute top-100 flex flex-col items-center gap-4">
        <div>{dynamicButton()}</div>
        <Hint
          text="Or press spacebar to play!"
          icon="/assets/images/keys/Spacebar.png"
          function={props.toGameplay}
        ></Hint>
      </div>
    </div>
  );
}
